import React, { Component, Fragment } from "react";
import queryString from "query-string";
import { Link } from "react-router-dom";

import api from "services/api";

import { Access } from "common";
import { Page, Panel, Loading, Pagination, Breadcrumbs } from "components";
import Filters from "./components/Filters";

class List extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Profissionais EAD", to: "/professionals" },
      { name: "Clientes EAD", to: "" },
    ],
    loading: true,
    customers: [],
    page: 1,
    total: 0,
    filter: {
      professional_cpf: null,
      created_at: null,
    },
  };

  async componentDidMount() {
    const { location } = this.props;

    const { page } = queryString.parse(location.search);

    this.loadData(page);
    this.setState({ page });
  }

  loadData = async (page = 1, filter) => {
    try {
      this.setState({ loading: true });
      const response = await api.get("/relationship/v2/customers", {
        params: {
          ...filter,
          presential_docs: true,
          page,
          per: 25,
        },
      });
      const { data, meta } = response.data;

      this.setState({
        customers: data,
        page: meta.current_page,
        total: meta.total_count,
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleFilter = (e) => {
    e.preventDefault();
    const { filter } = this.state;

    this.loadData(1, {
      ...filter,
      professional_cpf:
        filter.professional_cpf !== null ? filter.professional_cpf.value : null,
    });
  };

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;

    await this.setState({ filter: { ...filter, [name]: value } });
  };

  handleClean = async (e) => {
    e.preventDefault();

    this.setState({
      filter: {
        professional_cpf: null,
        created_at: null,
      },
    });
  };

  componentDidUpdate(oldProps) {
    const { location } = this.props;

    if (
      queryString.parse(oldProps.location.search).page !==
      queryString.parse(location.search).page
    ) {
      const { page } = queryString.parse(location.search);
      const { filter } = this.state;

      this.loadData(page, {
        ...filter,
        professional_cpf:
          filter.professional_cpf !== null
            ? filter.professional_cpf.value
            : null,
      });
      this.setState({ page });
    }
  }

  render() {
    const { breadcrumbs, customers, loading, page, total, filter } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Clientes EAD</Page.Title>

        <Panel className="panel-list">
          {Access.hasPermissions("manage-customer-presential") && (
            <Link
              to="/professionals/customers/create"
              className="button-add margin-bottom-20"
            >
              Atribuir Cliente
            </Link>
          )}

          <Filters
            data={filter}
            onChange={this.handleChangeFilter}
            onSubmit={this.handleFilter}
            onClean={this.handleClean}
          />

          {!customers.length && loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th className="big-size">nome ead</th>
                    <th>cpf do ead</th>
                    <th>cpf cliente</th>
                    <th>nome cliente</th>
                    <th>data vinculo</th>
                    <th>fim do vinculo</th>
                  </tr>
                </thead>
                <tbody>
                  {!customers.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {customers.map((customer, index) => (
                    <tr key={customer.id}>
                      <td>{customer.attributes.professional.name}</td>
                      <td>{customer.attributes.professional_cpf}</td>
                      <td>{customer.attributes.customer_cpf}</td>
                      <td>
                        {customer.attributes.customer !== null
                          ? customer.attributes.customer.name
                          : "-"}
                      </td>
                      <td>{customer.attributes.start_date}</td>
                      <td>{customer.attributes.end_date}</td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                className="m-t-20"
                current={page}
                total={total}
                {...this.props}
              />
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

export default List;
